const BrandGlyph = ({ className = "" }) => (
  <span
    aria-hidden="true"
    className={`brand-glyph inline-flex items-center justify-center shrink-0 ${className}`}
  >
    <svg viewBox="0 0 32 24" className="h-full w-full overflow-visible" role="presentation">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-[#b9854b]"
      >
        <ellipse cx="16" cy="12" rx="11.2" ry="4.8" transform="rotate(-18 16 12)" />
        <ellipse cx="16" cy="12" rx="11.2" ry="4.8" transform="rotate(42 16 12)" />
        <ellipse cx="16" cy="12" rx="11.2" ry="4.8" transform="rotate(-58 16 12)" />
      </g>

      <circle cx="16" cy="12" r="1.85" className="fill-[#b9854b]" />
      <circle cx="24.4" cy="6.5" r="1.45" className="fill-[#b9854b]" />
      <circle cx="7.4" cy="17.3" r="1.45" className="fill-[#b9854b]" />
    </svg>
  </span>
);

export default BrandGlyph;
